import ArtifactGroupType from "../base/ArtifactGroupType";


const KingPakalMask = {
  id: '149',
  name: "King Pakal's Mask",
  groupIcon: 'UnderTheCeiba',
  type: ArtifactGroupType.UNDER_THE_CEIBA,
  icon: 'KingPakalMask',
  power: 25,
  gameId: 'KingPakalsMask'
};

export default KingPakalMask;
